import { useEffect } from 'react';

type Section = { el: HTMLElement; bg: string };

export const usePageBg = (): void => {
  useEffect(() => {
    const sections: Section[] = Array.from(
      document.querySelectorAll<HTMLElement>('[data-page-bg]'),
    ).map((el) => ({ el, bg: el.dataset.pageBg ?? '' }));

    const pageBg = document.getElementById('page-bg');
    if (!pageBg || sections.length === 0) return;

    let raf = 0;
    const update = () => {
      raf = 0;
      const mid = window.scrollY + window.innerHeight * 0.5;
      let bestBg = sections[0].bg;
      let bestDist = Infinity;
      for (const s of sections) {
        const top = s.el.getBoundingClientRect().top + window.scrollY;
        const center = top + s.el.offsetHeight * 0.5;
        const dist = Math.abs(center - mid);
        if (dist < bestDist) {
          bestDist = dist;
          bestBg = s.bg;
        }
      }
      pageBg.style.backgroundColor = bestBg;
    };

    const schedule = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    const ro = new ResizeObserver(schedule);
    sections.forEach((s) => ro.observe(s.el));

    document.fonts?.ready.then(schedule).catch(() => undefined);

    update();

    return () => {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      ro.disconnect();
      if (raf) window.cancelAnimationFrame(raf);
    };
  }, []);
};
